/**
 * @module root/validations/validators
 */

import { withParams } from 'vuelidate';

let customPattern = function(pattern: string) {
  return withParams(
    { type: 'customPattern', pattern },
    patternPredicate.bind(null, pattern)
  );
};

export { customPattern };

function patternPredicate(pattern: any, value: string): boolean {
  if (!value || !pattern) return true;
  let actPattern = new RegExp(pattern);
  return actPattern.test(value);
}
